import { OnboardingStatusDefault } from 'components';
import { styled } from 'libs/ui/styled';

export const ContentStyled = styled(OnboardingStatusDefault)(() => ({
  marginTop: 0,
}));
